import { useNavigate } from 'react-router-dom';

const FinalCTA = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="py-20 bg-gradient-to-br from-pink-500 via-purple-500 to-pink-600 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        
        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="text-center">
            <img 
              src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
              alt="ReceptionGenie" 
              className="w-48 h-48 mx-auto mb-6 drop-shadow-2xl"
            />
            
            <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Stop Missing Customers. Let ReceptionGenie Handle Your Calls.
            </h2>
            
            <p className="text-xl lg:text-2xl text-pink-100 mb-12 max-w-3xl mx-auto leading-relaxed">
              Join hundreds of businesses that never miss a call, lead, or opportunity. Start your free demo today.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button 
                onClick={() => navigate('/payment')}
                className="whitespace-nowrap px-10 py-5 bg-white hover:bg-gray-100 text-pink-600 text-lg font-bold rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 cursor-pointer"
              >
                Sign Up Now
              </button>
              <a 
                href="tel:+18886009252"
                className="whitespace-nowrap px-10 py-5 bg-pink-700 hover:bg-pink-800 text-white text-lg font-bold rounded-xl border-2 border-white shadow-2xl hover:shadow-3xl transition-all duration-300 cursor-pointer text-center"
              >
                Call the AI Demo
              </a>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8 max-w-3xl mx-auto">
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-2">24/7</div>
                <div className="text-pink-100">Always Available</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-2">86%+</div>
                <div className="text-pink-100">Response Rate</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-white mb-2">$297</div>
                <div className="text-pink-100">Per Month</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinalCTA;